import React from 'react';
import geoMapTeaser from '../../images/geomap/geomap_teaser.png';
import { TEASER_EMAIL_CATALYST } from '../../actions/urlTypes';

const GeoMapTeaser = () => {
  return (
    <div>
      <div className="geo-map-width-455 minimize-tp float-left">
        <ul className="tool_bg" />
      </div>
      <div
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 57px)',
          overflowX: 'hidden',
        }}
      >
        <div className="geo-map-teaser-panel">
          <div className="heading1">Available Now!</div>
          <div className="heading2">
            Contact your representative or{' '}
            <u>
              <a href={`mailto:${TEASER_EMAIL_CATALYST}`}>
                {TEASER_EMAIL_CATALYST}
              </a>
            </u>{' '}
            for more information
          </div>
          <div className="heading3">
            <p>
              Geo Mapping lets Simmons Local Consumer Study users view target
              data based on various geographic definitions
            </p>
            <p>
              Get a granular view of your target by census region, state,
              market, county, and zip code
            </p>
          </div>
          <img src={geoMapTeaser} alt="Geo Mapping" className="heading-img" />
        </div>
      </div>
    </div>
  );
};

export default GeoMapTeaser;
